import type { FormProps, SanityMultiForm } from '#/lib/sanity/queries/form';
import { cn } from '#/lib/utils';
import { BasicText } from '#/components/BasicText';

import { MultiStepForm } from '../Multi';
import { addBusinessEmailValidation } from '../utils';
import { FormConfirmation } from './Confirmation';
import { FormErrorMessage } from './ErrorMessage';

export function FormCustomMultiStep(props: FormProps<SanityMultiForm>) {
  const formFieldsSchema = addBusinessEmailValidation(props.form);

  return (
    <div className={cn('relative', props.className)}>
      <MultiStepForm
        fieldGroups={props.form.fieldGroups}
        pardotCampaignId={props.form.pardotCampaignId}
        pardotListIds={props.form.pardotListIds}
        formFieldsSchema={formFieldsSchema}
        trackingEventName={props.form.trackingEventName}
        trackingEventProperties={props.form.trackingEventProperties}
        enableScheduling={props.form.enableScheduling}
        submitButtonLabel={props.form.submitButtonLabel}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
        ConfirmationComponent={({ isWaitingOnSchedulingLoad }) => (
          <FormConfirmation
            isWaitingOnSchedulingLoad={isWaitingOnSchedulingLoad}
            confirmation={props.confirmation}
          />
        )}
      >
        {({ formState }) => {
          return (
            <>
              <FormErrorMessage
                className="col-span-full"
                formState={formState}
              />

              {props.form.legalText ? (
                <BasicText
                  className="text-legal col-span-full mt-10 font-light text-grayscale-05"
                  value={props.form.legalText}
                />
              ) : null}
            </>
          );
        }}
      </MultiStepForm>
    </div>
  );
}
